import React from "react";

import BudgeRequire from "@/components/atoms/inputForms/BudgeRequire";

interface Props {
  label: string;
  isRequired?: boolean;
  border?: boolean;
  spBorder?: boolean;
  classNames?: string;
  htmlFor?: string;
  id?: string;
  disabled?: boolean;
  description?: string;
}

/*
 * 汎用フォームラベル
 */
export default function Label(props: Props) {
  const borderClasses = props.border ? " pl-2 border-l-2 border-l-theme" : "";

  const spBorderClasses = props.spBorder
    ? " pl-2 border-l-2 border-l-theme md:pl-0 md:border-l-0"
    : "";

  return (
    <>
      <label
        htmlFor={props.htmlFor}
        id={props.id}
        className={[
          `flex items-center text-[16px] font-bold text-color-gray_600 mb-2 break-word ${
            props.disabled ? "text-gray-300" : "font-bold"
          }`,
          props.classNames,
          borderClasses,
          spBorderClasses,
        ].join(" ")}
      >
        {props.label}
        {props.isRequired && <BudgeRequire />}
      </label>

      {props.description && (
        <div
          className="flex flex-col max-w-full break-word my-2"
          dangerouslySetInnerHTML={{
            __html: props.description,
          }}
        />
      )}
    </>
  );
}
